export const basicVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0,
  }
}

export const transition = {
  duration: 1,
  ease: [0.6, 0.01, 0, 0.9],

}